export default __webpack_public_path__ + "static/media/CK.b90ec89f.svg";